import { testimonials } from "@/data/content";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-2xl">
          <span className="eyebrow">Aims & Aspirations</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            What Aura aims to create
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              className="relative p-8 rounded-2xl bg-white border border-black/5"
            >
              <Quote
                size={22}
                className="absolute top-6 right-6 text-[var(--aura-teal)]/40"
              />
              <blockquote className="font-display text-lg md:text-xl leading-snug">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 font-ui text-xs uppercase tracking-[0.18em] text-[var(--aura-muted)]">
                {t.role}
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-6 font-body text-xs text-[var(--aura-muted)]">
          Sample placeholder copy — replace with real participant feedback after
          events.
        </p>
      </div>
    </section>
  );
}
